export const baseUrl = process.env.REACT_APP_BASE_URL_API;
export const blogRssBaseUrl = process.env.REACT_APP_BLOG_RSS_API;
